import { selectAdminUpdateToken } from '../store/slices/adminUpdate/adminUpdateSelectors';
import { getAPIManagerInstance } from './apiManager';
import { DECKARD_API_URL, httpMethodFunctions } from './common';

export const getCognitoUserIdByEmailAddressAsync = async (emailAddress) => {
  const { data } = await httpMethodFunctions.get(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/getUserIdByEmail/${emailAddress}`
  );
  return data;
};

export const getUserDetailsAuthTokenAsync = async (
  emailAddress,
  accessToken
) => {
  const { data } = await httpMethodFunctions.get(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/getUserByEmailAuth/${emailAddress}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      skipTokenRefresh: true, // need this to avoid an infinite loop
    }
  );
  return data;
};

export const createAccountAsync = async ({
  email,
  firstName,
  lastName,
  companyName,
  mailingAddress,
  phoneNumber,
  misc, // mailing adress components
}) => {
  const requestPayload = {
    email: email,
    firstName: firstName,
    lastName: lastName,
    companyName: companyName,
    phone: phoneNumber,
    mailingAddress: mailingAddress,
    misc: misc,
  };
  const { data } = await httpMethodFunctions.post(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/createAccount`,
    requestPayload
  );
  return data;
};

export const editPersonDetailsAsync = async ({
  accessToken,
  userId,
  email,
  firstName,
  lastName,
  companyName,
  mailingAddress,
  phoneNumber,
  misc, // mailing adress components
}) => {
  const requestPayload = {
    userId: userId,
    email: email,
    firstName: firstName,
    lastName: lastName,
    companyName: companyName,
    phone: phoneNumber,
    mailingAddress: mailingAddress,
    misc: misc,
  };
  const data = await httpMethodFunctions.post(
    `${DECKARD_API_URL}/${getAPIManagerInstance().cityIdentifier}/editPersonDetailsByUser`,
    { ...requestPayload },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return data;
};

export const getUserByEmailAddressRentalscapeAsync = async (
  state,
  emailAddress
) => {
  const accessToken = selectAdminUpdateToken(state);
  const { data } = await httpMethodFunctions.get(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/rentalscape/userByEmail/${emailAddress}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      skipTokenRefresh: true,
    }
  );
  return data;
};
